import { Button, IconButton, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { DynamicIcon, Tooltip } from 'src/components';
import { useCopyToClipboard } from 'src/utils/hooks';
import { toSxArray } from 'src/utils/sx';

interface CopyToClipboardButtonProps {
  content: string;
  onClick?: () => void;
  successMessage?: string;
  tooltipText?: string;
  children?: ReactNode;
  size?: 'large' | 'medium' | 'small';
  sx?: SxProps<Theme>;
}

export const CopyToClipboardButton = ({
  content,
  onClick,
  successMessage,
  tooltipText = 'Copy to clipboard',
  children,
  size = 'small',
  sx,
}: CopyToClipboardButtonProps) => {
  const { copyToClipboard } = useCopyToClipboard({ successMessage });

  const handleClick = async () => {
    await copyToClipboard(content);
    onClick?.();
  };

  return (
    <Tooltip title={tooltipText}>
      {children ? (
        <Button
          variant="text"
          size={size}
          onClick={handleClick}
          sx={{
            whiteSpace: 'nowrap',
            background: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
            color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
          }}
        >
          {children}
        </Button>
      ) : (
        <IconButton
          sx={[{ padding: 0 }, ...toSxArray(sx)]}
          aria-label="copy"
          onClick={handleClick}
        >
          <DynamicIcon name="copy" library="lucide" />
        </IconButton>
      )}
    </Tooltip>
  );
};
